import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import InputScreen from './InputScreen';
import LocalizationUIAssets from '../Localization-UIAssets';
import FontKeys from '../FontKeys';

export default class Intro extends Phaser.Scene
{
    static get KEY() { return 'Intro'; }

    constructor()
    {
        super({ key: (Intro).KEY });
    }

    create()
    {
        this.backgroundImage = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._intro_background, this).setOrigin(0);

        this.cloud = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2 - 100, LocalizationUIAssets._cloud, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);

        this.button = this.add.container(this.scale.width/2, this.scale.height/2 +150).setScale(0);
        const bg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._start_button, this.button);
        ABCyaPhaser.Container.setContainerInteractive(this.button);
        const txt = ABCyaPhaser.Text.addText(44,23, 44, 0xffffff, FontKeys._BPreplayBold, ABCyaPhaser.Localization.instance.getLocalizedString("start_button"), this.button, false).setOrigin(1, 0.5).setResolution(2);
        ABCyaPhaser.Text.resizeFontToFitWidth(txt, 140)
        ABCyaPhaser.Buttons.convertToButton(this.button, {onClick: ()=>{
          this.scene.start(InputScreen.KEY);
        }, soundKey: SoundAssetKeys._click});

        ABCyaPhaser.Tweens.addTween(this.button, 300, { scale: 1, delay: 200 }, Phaser.Math.Easing.Linear, () => this.loopButton());
    }

    loopButton()
    {
        this.tweens.timeline(
            {
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(this.button, 2800, { scale: 1.1 }, Phaser.Math.Easing.Bounce.Out),
                        ABCyaPhaser.Tweens.createTween(this.button, 2800, { scale: 1 }, Phaser.Math.Easing.Bounce.Out),
                    ],
                    loop: -1
            }
        );
    }
}